import Experience from '../Experience.js'
import * as THREE from 'three';

import basicVertexShader from '../shaders/basic/basic.vert'
import basicFragmentShader from '../shaders/basic/basic.frag'

export default class PosterBackground
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

    }

    init(){
        this.setGeometry()
        this.setTextures()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry()
    {
        this.geometry = new THREE.PlaneGeometry(2, 2, 1, 1)
    }

    setTextures()
    {
        this.texture = this.resources.items.posterBackgroundTexture
        this.texture.colorSpace = THREE.LinearSRGBColorSpace
        this.texture.SRGBColorSpace = true
    }

    setMaterial()
    {
        this.material = new THREE.ShaderMaterial({
            uniforms:
            {
                tTexture: { value: this.texture },
            },
            vertexShader: basicVertexShader,
            fragmentShader: basicFragmentShader,
        })
        this.material.needsUpdate = true
    }

    setMesh()
    {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.y = -1.
        this.mesh.position.z = 0.9
        this.scene.add(this.mesh)
        this.mesh.visible = false
    }

}